<template>
  <div class="userlist">
    <div>
      <div class="header">
        <div class="title">
          <ul>
            <li id="title-icon">
              <div></div>
              <span>ユーザー</span>
            </li>
          </ul>
        </div>
        <!-- <h1 class="title">ユーザー</h1> -->
      </div>
      <div class="section">
        <div class="container">
          <!-- <h2 class="title">ユーザ一覧</h2> -->
          <div class="sub-header">
            <div class="button-area">
              <span
                class="btn-submit"
                :class="{ disable: !isRootUser }"
                @click="addUser"
                >追加</span
              >
            </div>
            <ul>
              <li>
                <span class="message"
                  >アカウントを作成したユーザで追加、削除ができます</span
                >
              </li>
            </ul>
          </div>
          <table class="stripe">
            <tr>
              <th class="no">#</th>
              <th>メールアドレス</th>
              <th>氏名</th>
            </tr>
            <tr
              v-for="(row, index) in users"
              :key="index"
              @click="updateUser(index)"
            >
              <td style="text-align: center">{{ index + 1 }}</td>
              <td>{{ row.email }}</td>
              <td>{{ row.displayName }}</td>
            </tr>
          </table>

          <div class="button-area">
            <span
              v-if="this.nextToken"
              class="btn-submit btn-medium"
              @click="listUsers()"
              >もっと見る</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";

const PER_PAGE = 20;

export default {
  data() {
    return {
      users: [],
      nextToken: null,
      accountInfo: null,
      isRootUser: false,
    };
  },

  mixins: [Loader],

  async mounted() {
    this.$emit("hideMap");
    await this.listUsers();
  },

  methods: {
    ...mapActions([
      "showDetailUsers",
      "showAccount",
      "showAccountID",
      "showUserId",
    ]),

    addUser() {
      this.$router.push({ name: "users-detail" });
    },

    updateUser(index) {
      this.$router.push({
        name: "users-detail",
        params: {
          viewMode: "e",
          viewData: this.users[index],
          prmIsRootUser: this.isRootUser,
        },
      });
    },

    async listUsers(limit = PER_PAGE) {
      this.loading(async () => {
        // TODO actionへ
        let apiName = "AdminQueries";
        let path = "/listUsers";
        let myInit = {
          queryStringParameters: {
            limit: limit,
            token: this.nextToken,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          },
        };
        const { NextToken, Users } = await API.get(apiName, path, myInit);
        this.nextToken = NextToken;

        // ユーザデータの整形
        let userdata = Users.map((user) => {
          let data = {};
          data.username = user.Username;

          user.Attributes.forEach((attr) => {
            if (attr.Name === "email") {
              data.email = attr.Value;
            } else if (attr.Name === "custom:display_name") {
              data.displayName = attr.Value;
            } else if (attr.Name === "custom:user_id") {
              data.user_id = attr.Value;
            }
          });
          return data;
        });
        this.users = this.users.concat(userdata);

        const detailUsers = await this.showDetailUsers();
        for (var item of detailUsers) {
          let detail = this.users.find(function (element) {
            return element.user_id === item.user_id;
          });
          if (detail) {
            detail.color = item.color;
          }
        }

        const aid = await this.showAccountID();
        const uid = await this.showUserId();
        this.accountInfo = await this.showAccount(aid);
        if (
          this.accountInfo.root_users &&
          this.accountInfo.root_users.length > 0
        ) {
          this.isRootUser = this.accountInfo.root_users[0] === uid;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.userlist {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      .sub-header {
        display: flex;
        ul {
          margin: 0;
          list-style-type: none;
        }
        .message {
          font-size: 0.8rem;
          color: var(--col1);
        }
      }
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
    margin-bottom: 10px;
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.no {
      width: 10%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
    cursor: pointer;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    cursor: pointer;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    // margin: 10px auto 10px;
    margin-bottom: 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  .btn-medium {
    width: 150px;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_account-box.svg") no-repeat center
      center;
  }
}
.userDetail {
  display: flex;
  justify-content: center;
  * > div {
    width: 30rem;
  }
  .message {
    margin-bottom: 1rem;
  }
}
</style>
